import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Mails,
  Settings,
  UserRoundSearch,
  LogOut,
  Users,
  ChartColumnStacked,
  LayoutList,
  Store,
} from "lucide-react";
import { signOut } from "firebase/auth";
import auth from "../../../../firebase.init";

const AdminSidebar = ({ sidebarCollapsed, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      icon: <LayoutDashboard size={20} className="me-2" />,
    },
    {
      path: "/admin/orders",
      name: "Total Orders",
      icon: <Store size={20} className="me-2" />,
    },
    {
      path: "/admin/admins",
      name: "Admin Setting",
      icon: <Users size={20} className="me-2" />,
    },
    {
      path: "/admin/support-messages",
      name: "Support Messages",
      icon: <UserRoundSearch size={20} className="me-2" />,
    },
    {
      path: "/admin/settings",
      name: "Settings",
      icon: <Settings size={20} className="me-2" />,
    }
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  return (
    <div
      className={`col-auto px-0 ${
        sidebarCollapsed ? "col-md-1" : "col-md-3 col-xl-2"
      }`}
      style={{ position: "sticky", top: 0, height: "100vh" }}
    >
      <div
        className="d-flex flex-column h-100"
        style={{ backgroundColor: "#212529" }}
      >
        {/* Sidebar Header */}
        <div className="p-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <a
              href="/"
              className="d-flex align-items-center text-white text-decoration-none"
            >
              <span
                className={`fs-5 d-${
                  sidebarCollapsed ? "none" : "inline"
                } fw-bold`}
              >
                Menu
              </span>
            </a>
            <button
              className="btn btn-sm btn-dark"
              onClick={toggleSidebar}
              style={{ cursor: "pointer" }}
            >
              {sidebarCollapsed ? "→" : "←"}
            </button>
          </div>
        </div>

        {/* Scrollable Sidebar Body */}
        <div
          className="flex-grow-1 overflow-auto"
          style={{ scrollbarWidth: "thin" }}
        >
          <ul
            className="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start w-100 py-2"
            id="menu"
          >
            {navItems.map((item, index) => {
              const activeStyle = isActive(item.path)
                ? {
                    backgroundColor: "#495057",
                    borderRadius: "0.375rem",
                    width: "100%",
                  }
                : {};

              return (
                <li key={index} className="w-100">
                  <Link
                    to={item.path}
                    className="nav-link px-3 py-2 text-white w-100 d-flex align-items-center"
                    style={{ cursor: "pointer", ...activeStyle }}
                  >
                    {item.icon}
                    <span
                      className={`ms-1 d-${
                        sidebarCollapsed ? "none" : "inline"
                      }`}
                    >
                      {item.name}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Sidebar Footer */}
        <div className="border-top p-3 mt-auto">
          <button
            onClick={handleLogout}
            className="nav-link px-2 py-2 text-white w-100 d-flex align-items-center"
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <LogOut size={20} className="me-2" />
            <span className={`ms-1 d-${sidebarCollapsed ? "none" : "inline"}`}>
              Logout
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
